/*
 * Copyright Mimic Networks, Inc. 2026.
 */

import { AlertConfig, AlertConfigSortableFields, ListAlertConfigsData, ListAlertConfigsResponse } from '@/client';
import { mgmtPlaneAPIClient } from '@/client/mgmtPlane';
import { usePaginatedQuery } from '@/hooks/query/usePaginatedQuery';
import { useMgmtPlaneStateStore } from '@/state/mgmtPlaneStore';

export type UseAlertConfigsQueryParams = {
  params?: Omit<ListAlertConfigsData, 'tenantId'>;
  type?: 'inMemory' | 'queryParams';
};

export function useAlertConfigsQuery({ params, type }: UseAlertConfigsQueryParams = {}) {
  const selectedTenantId = useMgmtPlaneStateStore((state) => state.selectedTenantID);

  return usePaginatedQuery<
    ListAlertConfigsResponse,
    AlertConfig,
    unknown,
    AlertConfigSortableFields,
    ListAlertConfigsData
  >({
    apiCall: mgmtPlaneAPIClient.alerts.listAlertConfigs.bind(mgmtPlaneAPIClient.alerts),
    filterTypes: {},
    queryKey: 'alertConfigs',
    realtimeEvents: [],
    params: {
      tenantId: selectedTenantId!,
      ...params,
    },
    type,
    enabled: !!selectedTenantId,
  });
}
